import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { Box, MenuItem, TextField, Tooltip } from "@mui/material"

import { masterSchemaSlice } from "@/slice/masterSchemaSlice"
import { RootState } from "@/store"

export const TablePicker = React.memo(() => {
	const dispatch = useDispatch()

	const masterTableNames = useSelector((state: RootState) => {
		return state.masterSchema.data.filter((s) => s.allowSmEdit).map((s) => s.tableName)
	})
	const currentTableName = useSelector((state: RootState) => {
		return state.masterSchema.currentTableName
	})

	const [showTooltip, setShowTooltip] = React.useState(false)
	const [openPicker, setOpenPicker] = React.useState(false)

	const onOpenTooltip = React.useCallback(() => {
		setShowTooltip(!openPicker)
	}, [openPicker])
	const onCloseTooltip = React.useCallback(() => {
		setShowTooltip(false)
	}, [])
	const onChangeTable = React.useCallback((ev: React.ChangeEvent<HTMLInputElement>) => {
		dispatch(masterSchemaSlice.actions.setCurrentTableName(ev.target.value))
		setShowTooltip(false)
	}, [])
	const onOpenPicker = React.useCallback(() => {
		setOpenPicker(true)
		setShowTooltip(false)
	}, [])
	const onClosePicker = React.useCallback(() => {
		setOpenPicker(false)
		setShowTooltip(false)
	}, [])

	return (
		<Tooltip
			title="別のテーブルを表示します"
			placement="bottom-start"
			open={showTooltip}
			onOpen={onOpenTooltip}
			onClose={onCloseTooltip}
			enterDelay={1000}
			leaveDelay={100}
		>
			<Box
				component="form"
				sx={{
					"& .MuiTextField-root": { m: 1, width: "200px" },
				}}
				noValidate
				autoComplete="off"
			>
				<TextField
					select
					label="テーブル"
					value={currentTableName}
					onChange={onChangeTable}
					SelectProps={{ onOpen: onOpenPicker, onClose: onClosePicker }}
				>
					{masterTableNames.map((tableName) => (
						<MenuItem key={tableName} value={tableName}>
							{tableName}
						</MenuItem>
					))}
				</TextField>
			</Box>
		</Tooltip>
	)
})
